export default "__VITE_ASSET__Crtb42ZP__"